<template>
  <div>
    <div class="get-app userpage-bg-fill userpage-bg-fill--vox bg-vox-populi bg-animation">
      <div class="get-app-inner">
        <div class="get-app-main">
          <v-img
            src="/images/logo_login.png"
            max-width="360"
            width="100%"
            height="138"
            contain
            class="mx-auto"
          />

          <div class="locale-switch d-flex flex-wrap justify-content-center mt-3">
            <b-button
              v-for="code in localeCodes"
              :key="code"
              size="sm"
              class="m-1"
              :variant="locale === code ? 'primary' : 'outline-light'"
              @click="setLocale(code)"
            >
              {{ code.toUpperCase() }}
            </b-button>
          </div>

          <h1 class="get-app-title text-center text-white mt-4 mb-2">
            {{ strings.title }}
          </h1>
          <p class="get-app-body text-center text-white px-md-4">
            {{ strings.body }}
          </p>

          <div class="get-app-banners mt-4">
            <a
              :href="storeLinks.apple"
              class="get-app-banner-link"
              rel="noopener noreferrer"
            >
              <img
                src="/images/banner_app_store.png"
                alt="App Store"
                class="get-app-banner-img"
              >
            </a>
            <a
              :href="storeLinks.google"
              class="get-app-banner-link"
              rel="noopener noreferrer"
            >
              <img
                src="/images/banner_google_play.png"
                alt="Google Play"
                class="get-app-banner-img"
              >
            </a>
            <a
              :href="storeLinks.huawei"
              class="get-app-banner-link"
              rel="noopener noreferrer"
            >
              <img
                src="/images/banner_app_gallery.png"
                alt="App Gallery"
                class="get-app-banner-img"
              >
            </a>
          </div>
        </div>

        <div class="get-app-footer text-center text-white opacity-8">
          Copyright &copy; Onikom Ltd
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/** Replace when store URLs are final — used for mobile redirects and banner links */
const STORE_LINKS = {
  apple: "https://apps.apple.com/app/id6761615379",
  google: "https://play.google.com/store/apps/details?id=eu.onikom.voxpopuli",
  huawei: "https://appgallery.huawei.com/app/C117471383",
};

const LOCALE_CODES = ["en", "bg", "de", "fr", "es", "ru"];

const COPY = {
  en: {
    title: "Vox Populi",
    body:
      "Discover the truth behind every impression. This app turns people's opinions into a game – vote, compare, and see how others rate each other and you. Take part in duels, collect points, and climb the leaderboard while building your rating based on real votes. Voting and creating duels are completely anonymous, ensuring fair and unbiased evaluations. Fast, fun, and addictive – are you ready to find out what others think?",
  },
  bg: {
    title: "Vox Populi",
    body:
      "Открийте истината зад всяко впечатление. Това приложение превръща мненията на хората в игра – гласувайте, сравнявайте и вижте как другите оценяват вас и себе си. Участвайте в дуели, събирайте точки и се изкачвайте в класацията, като градите рейтинг, базиран на реални гласове. Гласуването и създаването на дуели са напълно анонимни, за честни и безпристрастни оценки. Бързо, забавно и пристрастяващо – готови ли сте да разберете какво мислят другите?",
  },
  de: {
    title: "Vox Populi",
    body:
      "Entdecken Sie die Wahrheit hinter jedem Eindruck. Diese App verwandelt die Meinungen der Menschen in ein Spiel – stimmen Sie ab, vergleichen Sie und sehen Sie, wie andere einander und Sie bewerten. Nehmen Sie an Duellen teil, sammeln Sie Punkte und steigen Sie in der Bestenliste auf, während Sie Ihre Bewertung auf Grundlage echter Stimmen aufbauen. Abstimmungen und die Erstellung von Duellen sind völlig anonym und gewährleisten faire, unvoreingenommene Bewertungen. Schnell, spaßig und süchtig machend – sind Sie bereit herauszufinden, was andere denken?",
  },
  fr: {
    title: "Vox Populi",
    body:
      "Découvrez la vérité derrière chaque impression. Cette application transforme les opinions en jeu : votez, comparez et voyez comment les autres s'évaluent et vous évaluent. Participez à des duels, collectez des points et grimpez au classement tout en construisant votre note grâce à de vrais votes. Le vote et la création de duels sont totalement anonymes pour des évaluations justes et impartiales. Rapide, amusant et addictif – êtes-vous prêt à savoir ce que pensent les autres ?",
  },
  es: {
    title: "Vox Populi",
    body:
      "Descubre la verdad detrás de cada impresión. Esta aplicación convierte las opiniones de las personas en un juego: vota, compara y mira cómo se califican unos a otros y a ti. Participa en duelos, acumula puntos y sube en la clasificación mientras construyes tu valoración con votos reales. Votar y crear duelos es completamente anónimo, lo que garantiza evaluaciones justas e imparciales. Rápido, divertido y adictivo: ¿estás listo para descubrir lo que piensan los demás?",
  },
  ru: {
    title: "Vox Populi",
    body:
      "Узнайте правду за каждым впечатлением. Это приложение превращает мнения людей в игру — голосуйте, сравнивайте и смотрите, как другие оценивают друг друга и вас. Участвуйте в дуэлях, набирайте очки и поднимайтесь в таблице лидеров, формируя рейтинг на основе реальных голосов. Голосование и создание дуэлей полностью анонимны, что обеспечивает честные и беспристрастные оценки. Быстро, весело и затягивает — готовы узнать, что думают другие?",
  },
};

function isMobileDevice() {
  const ua = navigator.userAgent || "";
  const maxTouch = navigator.maxTouchPoints || 0;
  if (/Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
    return true;
  }
  if (/Macintosh/i.test(ua) && maxTouch > 1) {
    return true;
  }
  return false;
}

/**
 * @returns {'desktop'|'apple'|'google'|'huawei'|'default'}
 */
function detectMobileStoreChannel() {
  if (!isMobileDevice()) {
    return "desktop";
  }
  const ua = navigator.userAgent || "";
  // App Store redirect: iPhone / iPod only — iPad stays on page (incl. iPadOS desktop-class UA)
  if (/iPhone|iPod/i.test(ua)) {
    return "apple";
  }
  if (/Huawei|Honor|HUAWEI|HMS|AppGallery/i.test(ua)) {
    return "huawei";
  }
  if (/Android/i.test(ua)) {
    return "google";
  }
  return "default";
}

export default {
  name: "GetApp",
  data() {
    const raw = (typeof navigator !== "undefined" && navigator.language
      ? navigator.language.split("-")[0].toLowerCase()
      : "en");
    const initialLocale = LOCALE_CODES.includes(raw) ? raw : "en";
    return {
      locale: initialLocale,
      localeCodes: LOCALE_CODES,
      storeLinks: { ...STORE_LINKS },
    };
  },
  computed: {
    strings() {
      return COPY[this.locale] || COPY.en;
    },
  },
  mounted() {
    this.maybeRedirectToStore();
  },
  methods: {
    setLocale(code) {
      if (LOCALE_CODES.includes(code)) {
        this.locale = code;
      }
    },
    maybeRedirectToStore() {
      const channel = detectMobileStoreChannel();
      if (channel === "apple" && this.storeLinks.apple) {
        window.location.replace(this.storeLinks.apple);
        return;
      }
      if (channel === "google" && this.storeLinks.google) {
        window.location.replace(this.storeLinks.google);
        return;
      }
      if (channel === "huawei" && this.storeLinks.huawei) {
        window.location.replace(this.storeLinks.huawei);
        return;
      }
    },
  },
};
</script>

<style scoped>
.get-app-inner {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 2rem 1rem;
}

.get-app-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
}

.get-app-title {
  font-size: 1.75rem;
  font-weight: 600;
}

.get-app-body {
  font-size: 1rem;
  line-height: 1.55;
  max-width: 640px;
  opacity: 0.95;
}

.get-app-banners {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  width: 100%;
}

.get-app-banner-link {
  display: block;
  max-width: 220px;
  width: 100%;
}

.get-app-banner-img {
  width: 100%;
  height: auto;
  display: block;
}

@media (min-width: 768px) {
  .get-app-banners {
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .get-app-banner-link {
    max-width: 200px;
    flex: 0 1 auto;
  }
}

.get-app-footer {
  flex-shrink: 0;
  padding-top: 2rem;
}
</style>
